var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterHomeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 18.2864C2.62496 18.0849 2.69463 17.8895 2.82219 17.7334C2.94975 17.5773 3.12736 17.4701 3.32491 17.43C4.11541 17.2685 4.82586 16.8389 5.33609 16.2139C5.84632 15.5889 6.125 14.8068 6.125 14C6.125 13.1932 5.84632 12.4111 5.33609 11.7861C4.82586 11.1611 4.11541 10.7315 3.32491 10.57C3.12736 10.5299 2.94975 10.4227 2.82219 10.2666C2.69463 10.1105 2.62496 9.91515 2.625 9.71357V7C2.625 6.76794 2.71719 6.54538 2.88128 6.38128C3.04538 6.21719 3.26794 6.125 3.5 6.125H24.5C24.7321 6.125 24.9546 6.21719 25.1187 6.38128C25.2828 6.54538 25.375 6.76794 25.375 7V9.71357C25.375 9.91515 25.3054 10.1105 25.1778 10.2666C25.0503 10.4227 24.8726 10.5299 24.6751 10.57C23.8846 10.7315 23.1741 11.1611 22.6639 11.7861C22.1537 12.4111 21.875 13.1932 21.875 14C21.875 14.8068 22.1537 15.5889 22.6639 16.2139C23.1741 16.8389 23.8846 17.2685 24.6751 17.43C24.8726 17.4701 25.0502 17.5773 25.1778 17.7334C25.3054 17.8895 25.375 18.0849 25.375 18.2864V21C25.375 21.2321 25.2828 21.4546 25.1187 21.6187C24.9546 21.7828 24.7321 21.875 24.5 21.875H3.5C3.26794 21.875 3.04538 21.7828 2.88128 21.6187C2.71719 21.4546 2.625 21.2321 2.625 21V18.2864Z",
    stroke: "#52616B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.125V21.875",
    stroke: "#52616B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHomeOff);
export default __webpack_public_path__ + "static/media/footer_home_off.c43a79d054746022f604a2dc5b6740db.svg";
export { ForwardRef as ReactComponent };